<template>
  <v-dialog v-model="dialog" width="400px">
    <v-card>
      <v-card-title class="headline">
        <v-icon>send</v-icon> Advertencia
      </v-card-title>
      <v-card-text>
        <h3>¿Está seguro de enviar el permiso:?</h3>
        <br />
        <h4>Nota: Ya no podrá realizar cambios</h4>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" @click.prevent="close()"> No </v-btn>
        <v-btn
          color="success"
          @click.prevent="enviarPermiso()"
          :loading="loading"
        >
          Sí
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {
      dialog: false,
      permiso: {},
      loading: false,
      id: null,
      id_persona: null,
      rol: {},
      // Variables para enviar correos
      datos_usuario: null,
    };
  },
  mounted() {
    this.$bus.$on("openDialogEnviarPermisoRRHH", async (item) => {
      this.id = item.permiso.id;
      this.permiso = item;
      // Obtnemos el correo del servidor seleccionado
      this.datos_usuario = await this.obtieneDatosPersona(
        this.permiso.id_persona
      );
      console.log(this.datos_usuario);
      this.dialog = true;
    });
  },
  methods: {
    // Envia correo al detinatario del permiso
    async enviarCorreoDestinatario(permiso) {
      let destinatario = await this.$service.obtieneDestinatarioPermiso(
        permiso.id_permiso
      );
      if (!destinatario) {
        return;
      }
      destinatario = JSON.parse(destinatario);
      var mensaje = `
            <h1>NOTIFICACIÓN SOLICITUD DE PERMISO</h1>
            Estimado(a): ${destinatario.nombres}<br>El motivo de la presente es para informarle que se le envio una solicitud de permiso con los siguientes datos:<br>
            <b>NOMBRE SOLICITANTE:</b>  <br>${permiso.nombres}<br>
            <b>TIPO DE PERMISO:</b>  <br>${permiso.tipo_permiso}<br>
            <b>NRO PAPELETA:</b>  <br>${permiso.numero}<br>
            <b>FECHA DE SOLICITUD:</b>  <br>${permiso.fecha_emision}<br>
            <b>FECHA SALIDA - FIN:</b>  <br>${permiso.fecha_desde} - ${permiso.fecha_retorno}<br>
            <b>HORAS:</b>  <br>${permiso.hora_desde} - ${permiso.hora_hasta}<br>
            <br>
            Ingrese al sistema para APROBAR o RECHAZAR EL PERMISO <br>
            Saludos cordiales.`;
      await this.$service.sendEmail({
        correo: destinatario.correo,
        asunto: `NOTIFICACIÓN SOLICITUD DE PERMISO`,
        mensaje: mensaje.replace(/<[^>]+>/g, ""),
        html: mensaje,
      });
    },
    close() {
      this.dialog = false;
      this.permiso = {};
      this.loading = false;
      this.$bus.$emit("closeDialogEnviarParaRRHH");
    },
    async obtieneDatosPersona(id_persona) {
      try {
        let usuario = null;
        let respuesta = await this.$service.graphql({
          query: `
          query{
              runQuery(consulta:"select u.correo,u.nombre_usuario,up.id_persona,u.id as id_usuario,p.ap_paterno,p.ap_materno,p.nombres from seguridad.usuario_persona up join seguridad.usuario u  on up.id_usuario =u.id join persona.persona p on up.id_persona =p.id  where up.id_persona =  ${id_persona}"){
                respuesta
              }
            }
          `,
        });
        respuesta = respuesta.runQuery.respuesta;
        if (respuesta.length > 0) {
          usuario = respuesta[0];
        }
        return usuario;
      } catch (error) {
        console.log(error);
      }
    },
    async enviarPermiso() {
      let user = this.$storage.get("user");
      let id_persona = null;
      const permiso_copia = JSON.parse(JSON.stringify(this.permiso));
      if (this.$route.params.id !== undefined) {
        id_persona = parseInt(this.$route.params.id);
      }
      if (
        //this.permiso.permiso.id_tipo_permiso == 96 ||
        //this.permiso.permiso.id_tipo_permiso == 6 ||
        this.permiso.permiso.id_tipo_permiso == 12 ||
        // this.permiso.permiso.id_tipo_permiso == 61 ||
        (this.permiso.permiso.id_tipo_permiso >=37 && this.permiso.permiso.id_tipo_permiso <=43)
      ) {
        try {
          let respuesta = await this.$service.graphql({
            query: `
              query{
                  runQuery(consulta:"select control.fn_solicita_tolerancia(${this.id},6,${user.id})"){
                    respuesta
                  }
                }	
            `,
          });
          let resp = respuesta.runQuery.respuesta[0].fn_solicita_tolerancia;
          let resp2 = resp.split("|");
          let correcto2 = resp2[0];
          if (correcto2 == "1") {
            this.permiso.id_estado = 6;
            this.$confirm("El permiso fue solicitado exitosamente", () => {});
            this.close();
          } else {
            this.$confirm(resp2[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }



      if (this.permiso.id_tipo_permiso == 8) {
        try {
          let respuesta = await this.$service.graphql({
            query: `
                                        query{
                                          runQuery(consulta:"select control.fn_solicita_justifica_caja(${this.id},6,${user.id})"){
                                          respuesta
                                          }
                                        }
                                        `
          });

          let resp = respuesta.runQuery.respuesta[0].fn_solicita_justifica_caja;
          let resp2 = resp.split("|");
          if (resp2[0] === "1") {
            this.permiso.id_estado = 6;
            this.$confirm("El permiso fue solicitado exitosamente", () => {});
          } else {
            this.$confirm(resp2[1], () => {});
          }
          this.close();
        } catch (error) {
          //cierra try
          console.log(error);
        } //cierra catch
      }


      await this.enviarCorreoDestinatario(permiso_copia);
      this.loading = false;
    },

    getUserId() {
      const user = this.$storage.get("user");
      return parseInt(user.id_persona);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/admin/permiso/dialogs/EnviarPermisoRRHH.vue